import { useState } from 'react';

const galleryImages = [
  {
    src: 'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/d0e37f09015cd61aab5c69596d219369.jpeg',
    alt: '학원 복도 및 내부',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/ead26d3e-f499-4062-b7b8-1c25e1dbd7d1_KakaoTalk_20231108_151330778.jpg?v=d03059112f5401981972bb74312ee94a',
    alt: '학원 내부',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/c2cf9857-4939-4e7c-bbdd-ffe9fdde114b_KakaoTalk_20231108_151330778_01.jpg?v=ee77e9d116504f7632e947f46df9ba62',
    alt: '학원 내부 2',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/607148ee-faf6-4010-9d16-f09b4a774dff_KakaoTalk_20250617_182410467_08.jpg?v=98fc43f2300ed5c792e5062ec562856b',
    alt: '학원 내부 3',
  },
];

interface GalleryModalProps {
  onClose: () => void;
}

export default function GalleryModal({ onClose }: GalleryModalProps) {
  const [selected, setSelected] = useState<number | null>(null);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="w-full max-w-5xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="text-red-500 text-xs font-semibold tracking-widest uppercase">Gallery</p>
            <h2 className="font-serif-kr font-black text-white text-2xl mt-1">학원 둘러보기</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-lg" />
          </button>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {galleryImages.map((img, i) => (
            <button
              key={i}
              onClick={() => setSelected(i)}
              className="relative group overflow-hidden rounded-xl cursor-pointer"
            >
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 rounded-xl flex items-center justify-center">
                <i className="ri-zoom-in-line text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="absolute bottom-2 left-2 right-2">
                <p className="text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/60 rounded px-2 py-0.5 text-center">{img.alt}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selected !== null && (
        <div
          className="fixed inset-0 z-60 flex items-center justify-center bg-black/95 p-4"
          onClick={() => setSelected(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 transition-colors cursor-pointer z-10"
            onClick={() => setSelected(null)}
          >
            <i className="ri-close-line text-white text-lg" />
          </button>
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 transition-colors cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); setSelected((selected - 1 + galleryImages.length) % galleryImages.length); }}
          >
            <i className="ri-arrow-left-line text-white" />
          </button>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700 transition-colors cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); setSelected((selected + 1) % galleryImages.length); }}
          >
            <i className="ri-arrow-right-line text-white" />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="w-full h-[60vh] rounded-2xl overflow-hidden">
              <img
                src={galleryImages[selected].src}
                alt={galleryImages[selected].alt}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-center text-neutral-400 text-sm mt-3">{galleryImages[selected].alt}</p>
            <p className="text-center text-neutral-600 text-xs mt-1">{selected + 1} / {galleryImages.length}</p>
          </div>
        </div>
      )}
    </div>
  );
}
